export const rp1 = {
  Id: 410,
  ReasonCode: "4837",
  ReasonCodeDescription: "No Cardholder Authorization",
  ReasonCodeCagtegory: "Fraud",
  ReasonCodeAllowedDaysToDispute: 120,
  DisputeDate: "2021-11-05T00:00:00",
  DisputeAmount: 24.95,
  ChargebackArrivedTooLate: false,
  Chargeback: {
    ChargebackId: 19953,
    MerchantAccountName: "Blue Lake Discount Savings Pass  - F1 - 1721",
    Amount: 24.95,
    ReferenceTransactionAmount: 24.95,
    ConsumerName: "LUTRELL HUDDLESTON",
    TransactionDate: "2021-08-22T10:28:49",
    DisputeDate: "2021-11-05T00:00:00Z",
    Currency: "USD",
    ExternalChargebackId: "6517815009",
    BIN: "559758",
    LastFour: "4227",
    AccountNumber: "559758xxxxx4227",
    Descriptor: null,
    DescriptorContact: null,
    ChargebackType: "",
    ChargebackLastAction: "",
    ChargebackCycle: "",
    CycleState: "CHGM-Charge Merchant",
    CycleStateCategory: null,
    SourceCycleState: null,
    CycleStateCode: null,
    TransactionType: null,
    PaymentType: "PREPAID",
    ExpirationDate: "0623",
    AuthorizationCode: "HO5QVY",
    OrderId: null,
    ExternalOrderId: "5106755",
    ARN: "05436841234200018105613",
    FirstName: "LUTRELL",
    LastName: "HUDDLESTON",
    CRMUserName: null,
    CRMPassword: null,
    CRMSearchUrl: null,
    CurrentCycle: "First Chargeback",
    ChargebackState: "New",
    CanBeActedOn: true,
    StatusIsPreArbLost: false,
    CardBrandImage: "mastercard.png",
    CardBrand: "MASTERCARD",
    Issuer: "COMERICA BANK",
    CardTypeFromBIN: "PREPAID",
    Category: "PREPAID GOVERNMENT",
    Country: "UNITED STATES",
    CountryISO: "US",
    ReasonCode: "4837",
    ReasonCodeDescription: "4837",
    CBCategory: null,
    Action_Id: null,
    ActionChoices: null,
    FoughtNotFoughtReason_Id: null,
    FoughtNotFought: "accept",
    ChargebackSource: "AccessMyIQ",
    Deadline: "2021-11-19T00:00:00Z",
    ReceivedDate: "2021-11-09T09:16:58.83",
    AgeHours: 29615,
    TimeBetweenTransactionAndDispute: 1789,
    AgeDays: 1233,
    DaysBetweenTransactionAndDispute: 74,
    Notes: "",
    Files: null,
    ChargebackActions: [],
    ChargebackCycles: [
      {
        Date: "2021-11-05T00:00:00",
        Other: null,
        ActionBy: "sys",
        Cycle: "First Chargeback",
        CycleState: "CHGM-Charge Merchant",
        CycleStateCode: null,
        CycleStateCategory: null,
        SourceCycleState: null,
        Amount: 24.95
      }
    ],
    Documents: null,
    ExternalTransactionId: "6517815009",
    TransactionId: 1872188,
    PriorRefund: null,
    PriorAlert: null,
    PriorRDR: null,
    ProcessorCaseId: null,
    ProcessorMerchantId: "4445027891721",
    ProcessorDBA: null,
    ReplyByDate: "2021-11-19T00:00:00",
    ExtraManageChoice: null,
    ExtraManageChoice2: null,
    UserDefinedChoice: null,
    UserDefinedChoice2: null
  },
  RepresentmentTransactionInfo: {
    Amount: 24.95,
    CardBrand: "MASTERCARD",
    CardNumber: "559758xxxx4227",
    ExpDate: "0623",
    Cycle: null,
    TransactionDate: "2021-08-22T10:28:00",
    AuthCode: "HO5QVY",
    CancelStatus_Id: null,
    Cancelled: false,
    CancelDate: null,
    CancelReason: null,
    WasCustomerServiceContacted: false,
    LastCustomerServiceContactDate: null,
    LastCustomerServiceContactReason: null,
    DeviceId: null,
    GeoId: null,
    OTP_SMS: null,
    TransactionAmount: 24.95,
    AVSMatchCode_Id: 1,
    TransactionAVSCode: "Y",
    AVSCode: "Y",
    AVSCodeDescription: "Exact match, 5-character numeric ZIP",
    CVSMatchCode_Id: null,
    ThreeDSecure_Id: null,
    ExternalTransactionId: "6517815009",
    ExternalRefundId: null,
    RefundTransaction_Id: null,
    RefundARN: null,
    RefundAuthCode: null,
    RefundStatus_Id: null,
    RefundAmount: null,
    RefundDate: null,
    Issuer: "COMERICA BANK",
    Case_Id: null,
    ExternalAlertId: null,
    AlertInfo: null,
    AlertProvider_Id: null,
    AlertProvider: null,
    AddOns: null,
    HasProof: null,
    ProofDate: null,
    ProofType: null,
    SubscriptionCycle: null,
    SubscriptionParentId: null,
    IPAddress: null,
    CRMUserName: null,
    Descriptor: null,
    SettlementDate: null,
    NotRefundedAmount: null,
    Notes: []
  },
  OrderInfo: {
    Id: 0,
    ShipToDifferent: false,
    ReturnAttemptTooLate: null,
    Products: [
      {
        Id: 0,
        ProductId: "RS50OFF6MFREESHIP",
        Quantity: 1,
        PricePer: 179.85,
        Total: 179.85,
        Name: "Relaxium Sleep 6 month supply (R) FREE SHIP",
        Description: "Relaxium Sleep 6 month supply (R) FREE SHIP",
        Sku: "RS50OFF6MFREESHIP",
        WasReturned: null
      },
      {
        Id: 0,
        ProductId: "XSCALM3",
        Quantity: 1,
        PricePer: 59.95,
        Total: 59.95,
        Name: "Relaxium Calm B2G1 FREE (1)",
        Description: "Relaxium Calm B2G1 FREE (1)",
        Sku: "XSCALM3",
        WasReturned: null
      },
      {
        Id: 0,
        ProductId: "Focus_Max_1_BTL",
        Quantity: 1,
        PricePer: 59.96,
        Total: 59.96,
        Name: "Focus Max B2G1",
        Description: "Focus Max B2G1",
        Sku: "Focus_Max_1_BTL",
        WasReturned: null
      }
    ],
    BillingContact: {
      Id: 416,
      Name: "LUTRELL HUDDLESTON",
      Address: "970 BUCHANAN ST",
      City: "SAN FRANCISCO",
      State: "CA",
      Zip: "94102",
      Country: "US"
    },
    ShippingContact: {
      Id: 0,
      Name: null,
      Address: null,
      City: null,
      State: null,
      Zip: null,
      Country: null
    },
    MerchantOrderId: "5106755",
    DeliveryLocation: null,
    DeliveryNotes: null,
    DateOfOrder: null,
    Email: "",
    IPAddress: "206.176.224.10",
    Shipper_Id: null,
    ShipperName: null,
    ShippingJson: null,
    TrackingNumber: "",
    DateDelivered: "2021-08-28T10:28:00",
    Tax: null,
    Shipping: null,
    DateShipped: "2021-08-24T10:28:00",
    CarRentalDate: "2021-08-22T10:28:00",
    CarReturnDate: "2021-08-25T10:28:00",
    FlightDate: "2021-08-22T10:28:00",
    CheckInDate: "2021-08-22T10:28:00",
    CheckOutDate: "2021-08-26T10:28:00",
    AncillaryCharges: null,
    NoShow: true,
    CancelAttemptTooLate: true,
    Refundable: null,
    Phone: null,
    OrderAmount: 0,
    Currency: null,
    MarketingSource: null,
    SubMarketingSource: null
  },
  Documents: [
    {
      Id: 249,
      RepresentmentSupportingDocumentId: 241,
      Src: "api/representment/GetRepresentmentImageSec?guid=faf59d14-7b1b-4c95-992c-b3eb97b38b27",
      Title: "Transaction Details",
      Category: "Order Documents",
      DocumentType: "Transaction History",
      Notes: "A positive AVS code Y is a strong indication that the customer is tied to the address we were given.",
      Guid: "faf59d14-7b1b-4c95-992c-b3eb97b38b27",
      DocumentType_Id: 18,
      Global: false
    },
    {
      Id: 250,
      RepresentmentSupportingDocumentId: 242,
      Src: "api/representment/GetRepresentmentImageSec?guid=7ee030dc-e45b-45ae-bff3-35c3cc8485b5",
      Title: "Invoice",
      Category: "Order Documents",
      DocumentType: "Invoice",
      Notes: "",
      Guid: "7ee030dc-e45b-45ae-bff3-35c3cc8485b5",
      DocumentType_Id: 19,
      Global: false
    },
    {
      Id: 251,
      RepresentmentSupportingDocumentId: 243,
      Src: "api/representment/GetRepresentmentImageSec?guid=e564f8d6-42e4-41e9-8be8-f308a035f802",
      Title: "Order Details",
      Category: "Order Documents",
      DocumentType: "Signed Contract",
      Notes: "As shown in the illustration, the order details include the product and price of the service provided, along with the customer information. All pertinent information is documented for reference.",
      Guid: "e564f8d6-42e4-41e9-8be8-f308a035f802",
      DocumentType_Id: 11,
      Global: false
    }
  ],
  AdditionalTransactions: [],
  CustomDisputeValues: [],
  DaysBetweenCancellationAndCB: null,
  DaysBetweenRefundAndCB: null,
  TemplateId: null
}